import React from 'react';
import '../../styles/styles.css';

export default function srisailam() {
  return (
    <div className="container mt-4">
        <div className="row">
           
            <div className="col-md-4 box1">
            <img src="/images/Srisailam.jpg" alt="Sri Mallikarjuna Sametha Brahmarambika" />    
            </div>

            <div className="col-md-8">
                <div className="Reg-box2">
                    <p><strong>Important Festivals to visit<br />
    Dussehra Navratri, MahaShivaratri<br />    
    <br />

  </strong></p>
  <p>Online Seva Bookings : <a href="https://www.srisailadevasthanam.org/en-in/devotee/signin?to=devotee-app/online-booking/pratyaksha-seva" target="_blank" rel="noopener noreferrer">
  Srisailam Seva Bookings
</a>
</p>
         </div>
            </div>
        </div>

       
        <div className="row mt-3">
            <div className="col-12 Desc-box3">
             <p>Srisailam has great ancient significance. Among the 12 Jyotirlingas, the 2nd is the Mallikarjuna Swamy Lingam; among the 18 Maha Shakti Peethas, the 6th is Sri Bhramaramba Devi temple. Srisailam is the only temple where two such icons exist under one temple premise, such is its significance. World's Mother and Father, Lord Shiva and Goddess Parvathi with all the powers vested in them start their journey towards, Earth's Kailasa, the world's centre, home to Vedas, Upasanakendra, their new called home, Srisaila Kshetram. The only Lord Shiva's Dhaamam that's going to remain before and after the Universe is Srisaila Kshetram.</p>
            </div>
        </div>

        <div className="row mt-3">
        <div className="col-12">
          <div className="Desc-box3">
            <h2 className="live-header">Srisailam </h2>
            <div className="youtube-container">
              <iframe
                src="https://www.youtube.com/embed/EuHVouwLMbo?si=DKQhk3S2u0W27sC5"
                title="Annavaram Documentary"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
